import React from "react";
import { AspectRatio, Link, LinkOff, Save } from "@mui/icons-material";
import { Button, IconButton, Menu, MenuItem, Paper, Stack, TextField, Tooltip } from "@mui/material";
import { styled } from '@mui/material/styles';

const IB = styled(IconButton)(({ theme }) => ({
    borderRadius: 0,
}));

export default function ImagemSizeComp(props) {
    const { onSelect, image } = props;

    const [width, setWidth] = React.useState();
    const [height, setHeight] = React.useState();
    const [on, setOn] = React.useState(true);
    const [salvar, setSalvar] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);

    React.useEffect(() => {
        if (image) {
            let originalWidth = image.naturalWidth;
            let originalHeight = image.naturalHeight;
            setWidth(originalWidth);
            setHeight(originalHeight);
        }
    }, [image])

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleChangeLargura(e) {
        setSalvar(true );
        let val = e.target.value;
        if (on) {
            let originalWidth = image.naturalWidth;
            let originalHeight = image.naturalHeight;
            let aspectRatio = originalWidth / originalHeight;
            let newHeight = Math.round(val / aspectRatio);
            
            setWidth(val)
            setHeight(newHeight);
        } else {            
            setWidth(val);
        }
    }
    function handleSave(){
        image.width = width;
        image.height = height;
    }
    return (
        <React.Fragment>
            <Tooltip title="Ajustar tamanho">
                <IB
                    onClick={handleClick}
                    size="small"
                >
                    <AspectRatio />
                </IB>
            </Tooltip>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                <Paper sx={{ width: 320, maxWidth: '100%', p: 2 }}>
                    <Stack spacing={2}>
                        <TextField type="number" label="Largura" variant="outlined"
                            size="small"
                            value={width} onChange={handleChangeLargura}
                        />

                        <Button size="small" variant="outlined" onClick={() => setOn(!on)}
                            startIcon={on ? <Link /> : <LinkOff />}>
                            {on ? "Proporção ligada" : "Proporção desligada"}
                        </Button>


                        <TextField type="number" label="Altura" variant="outlined"
                            size="small"
                            value={height} onChange={(e) => setHeight(e.target.value)}
                        />
                        {salvar &&
                            <Button size="small" variant="outlined" onClick={handleSave}
                                startIcon={<Save />} >
                                Aplicar modificação
                            </Button>
                        }
                    </Stack>
                </Paper>
            </Menu>
        </React.Fragment>
    )
}